import { render } from "./PasswordForgetForm.vue?vue&type=template&id=4d490b5c"
import script from "./PasswordForgetForm.vue?vue&type=script&lang=js"
export * from "./PasswordForgetForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__